import clsx from 'clsx';
import React, { useEffect, useMemo, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formatNumber } from '../services/helpers';
import { useAppSelector } from '../store/hooks';
import { saleSelector, setSaveChangeInBalance, setTotal, updateSalePaymentMethods } from '../store/sale-slice';
import PinModal from './pin-modal';
import ReturnPaymentMethods from './return-payment-methods';

const SaleUpdatePaymentMethods = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const organization = useAppSelector((state) => state.auth.organization!);
  const { change, pending, total, saveChangeInBalance, loading, sale, previosNextSale, requesting } = useSelector(saleSelector);
  const [showPinModal, setShowPinModal] = useState(false);

  useEffect(() => {
    if (sale?.total) {
      dispatch(setTotal(sale.total));
    }
  }, [sale?.total, dispatch]);

  const disabledFinalizedButton: boolean = useMemo(() => {
    if (loading || requesting) {
      return true;
    }
    return pending !== 0;
  }, [loading, pending, requesting]);

  const onFinalizePayment = () => {
    if (organization.requireTransactionPin) {
      setShowPinModal(true);
      return;
    }
    onUpdateSalePaymentMethod(null);
  };

  const onUpdateSalePaymentMethod = async (pin: string | null) => {
    const result = (await dispatch(updateSalePaymentMethods(pin))) as any;
    if (result.payload) {
      window.location.reload();
    }
  };

  if (!sale) {
    return null;
  }

  return (
    <React.Fragment>
      <div className="sale-payment make-payment h-100">
        <div className="d-flex flex-column h-100 position-relative">
          <div className="mb-auto px-4 pt-3">
            <div className="d-flex flex-row justify-content-between">
              <div className="come-back clickable">
                <ChevronLeft className="me-1" size={14} />
                <span
                  className={clsx('prev-next', { disabled: !previosNextSale?.previousSaleId })}
                  onClick={() => {
                    if (previosNextSale?.previousSaleId) {
                      navigate(`/venta/${previosNextSale.previousSaleId}`);
                    }
                  }}
                >
                  Anterior
                </span>
              </div>
              <div className="text-center mb-3 ">
                <h1>Actualizar métodos de pago</h1>
              </div>
              <div className="come-back clickable">
                <span
                  className={clsx('prev-next', { disabled: !previosNextSale?.nextSaleId })}
                  onClick={() => {
                    if (previosNextSale?.nextSaleId) {
                      navigate(`/venta/${previosNextSale.nextSaleId}`);
                    }
                  }}
                >
                  Siguiente
                </span>
                <ChevronRight className="me-1" size={14} />
              </div>
            </div>
            <div className="d-flex flex-row justify-content-between mb-3">
              <div className="d-flex flex-column payment-columns me-4">
                <ReturnPaymentMethods />
              </div>
              <div className="d-flex flex-column payment-columns ms-4">
                <div className="d-flex flex-column container-money mb-3">
                  <span className="title">Total</span>
                  <span className="value">{formatNumber(total)}€</span>
                </div>
                <div className={clsx('d-flex flex-column container-money mb-3', { alert: pending < 0 || pending > 0, inactive: pending === 0 })}>
                  <span className="title">Pendiente</span>
                  <span className="value">{formatNumber(pending)}€</span>
                </div>
                <div className={clsx('d-flex flex-column container-money mb-3', { success: change > 0, inactive: change === 0 })}>
                  <span className="title">Cambio total</span>
                  <div className="d-flex flex-column justify-content-between">
                    <span className="value">{formatNumber(change)}€</span>
                    {change > 0 && (
                      <div className="save-balance">
                        <input type="checkbox" checked={saveChangeInBalance} onChange={(e: any) => dispatch(setSaveChangeInBalance(e.target.checked))} />
                        <label>Guardar en saldo</label>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container-buttons">
            <button onClick={onFinalizePayment} disabled={disabledFinalizedButton} className={clsx('finalize-button', { 'valid-sale': pending === 0 && total >= 0 })}>
              Actualizar
            </button>
          </div>
        </div>
      </div>
      <PinModal
        show={showPinModal}
        onCloseModal={(pin) => {
          setShowPinModal(false);
          if (pin === null || pin.length !== 4) {
            return;
          }
          onUpdateSalePaymentMethod(pin);
        }}
      />
    </React.Fragment>
  );
};

export default SaleUpdatePaymentMethods;
